import { Schema } from '@core/data/dto/schema';
import { getLocalMomentFromUtc } from '@core/utils/date-time';
import moment from 'moment';

export const LeavePolicySchema = {
    id: Schema.String,
    name: Schema.String,
    version: Schema.Number,
    type: Schema.String,
    sub_type: Schema.Auto,
    category: Schema.String,
    status: Schema.String,
    description: Schema.String,
    members: Schema.Auto,
    policy_details: {
        map: 'policyDetails',
        mapImport: (value: any, dto: any) => ({
            timeoffName: value?.timeoff_name
        })
    },
    policy: {
        map: 'policy',
        mapImport: (value: any, dto: any) => ({
            annualLeaveHours: value.annual_leave_hours,
            carryoverLimit: value.carryover_limit,
            maximumAccrual: value.maximum_accrual,
            balanceResetDate: moment(`${ value.balance_reset_date }-${moment().format('YYYY')}`),
            balanceResetType: value.balance_reset_type,
            terminationPayout: value.termination_payout,
            accrualLeaveHours: value.accrual_leave_hours,
            accrualWorkedHours: value.accrual_worked_hours,
            dailyWaitingPeriod: value.daily_waiting_period,
            prorateLeaveAccrual: value.prorate_leave_accrual
        })
    },
    created_at: {
        map: 'createdAt',
        mapImport: (value: any) => (
            getLocalMomentFromUtc(value)
        )
    },
    updated_at: {
        map: 'updatedAt',
        mapImport: (value: any) => (
            getLocalMomentFromUtc(value)
        )
    },
    updatedBy: Schema.String
};
